import React from "react";
import { Link } from "react-router-dom";
import { ProductConsumer } from "../context";
import { ButtonContainer } from "./styles/ButtonContainer";
import { ModalContainer } from "./styles/ModalContainer";

export default function Modal() {
  return (
    <ProductConsumer>
      {({ modalOpen, closeModal, modalProduct }) => {
        const { img, title, price } = modalProduct;

        if (!modalOpen) {
          return null;
        } else {
          return (
            <ModalContainer>
              <div className="row">
                <div
                  id="modal"
                  className="col-8 mx-auto text-center text-capitalize p-5"
                >
                  <h5>item added to the cart</h5>
                  <img src={img} alt={title} className="img-fluid" />
                  <p>{title}</p>
                  <p className="text-muted">price : ${price}</p>
                  {/* Buttons */}
                  <Link to="/" onClick={closeModal}>
                    <ButtonContainer>continue shopping</ButtonContainer>
                  </Link>
                  <Link to="/cart" onClick={closeModal}>
                    <ButtonContainer cart>go to cart</ButtonContainer>
                  </Link>
                </div>
              </div>
            </ModalContainer>
          );
        }
      }}
    </ProductConsumer>
  );
}
